<template>
  <div v-if="pages && pages.pages > 1" class="row">
    <div class="col-sm-3 pt-3">
      Página <b>{{ pages.current }}</b> de <b>{{ pages.last }}</b>
    </div>
    <div class="col-sm-9">
      <nav aria-label="Paginador">
        <ul class="pagination justify-content-end">
          <li class="page-item" :class="pages.current == 1 ? 'disabled' : ''">
            <a
              class="page-link"
              style="cursor: pointer;"
              @click="pages.current != 1 && changePage(1)"
              title="Página 1"
            >
              <i class="bi bi-chevron-bar-left"></i>
            </a>
          </li>
          <li class="page-item" :class="pages.prev ? '' : 'disabled'">
            <a
              class="page-link"
              style="cursor: pointer;"
              @click="pages.prev && changePage(pages.prev)"
              :title="'Página ' + pages.prev"
            >
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
          <li
            v-for="n in pages.pages"
            class="page-item"
            :class="pages.current == calcPage(n) ? 'active' : ''"
            v-bind:key="n"
          >
            <a
              class="page-link"
              style="cursor: pointer;"
              @click="calcPage(n) != pages.current && changePage(calcPage(n))"
              :title="'Página ' + calcPage(n)"
              >{{ calcPage(n) }}</a
            >
          </li>
          <li class="page-item" :class="pages.next ? '' : 'disabled'">
            <a
              @click="pages.next && changePage(pages.next)"
              class="page-link"
              style="cursor: pointer;"
              :title="'Página ' + pages.next"
            >
              <i class="bi bi-chevron-right"></i>
            </a>
          </li>
          <li
            class="page-item"
            :class="pages.current == pages.last ? 'disabled' : ''"
          >
            <a
              class="page-link"
              style="cursor: pointer;"
              @click="pages.current != pages.last && changePage(pages.last)"
              :title="'Página ' + pages.last"
            >
              <i class="bi bi-chevron-bar-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "Paginador",
  props: ["pages"],
  methods: {
    calcPage: function(page) {
      return page + this.pages.from - 1;
    },
    changePage: function(page) {
      this.$emit("selPage", page);
    }
  }
};
</script>

<style scoped>
.page-link {
  cursor: pointer;
}
</style>
